module.exports = __webpack_public_path__ + "static/media/mischarHogen.4813d1bf.png";